import * as React from 'react';
import { HowAcademyWorksItem as THowAcademyWorksItem } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import * as styles from './how-academy-works-item.module.scss';

type Props = {
  item: THowAcademyWorksItem;
};

const HowAcademyWorksItem: React.FC<Props> = ({ item }) => (
  <li className={styles.item}>
    <h3 className={styles.title}>
      <FormattedMessage message={item.title} />
    </h3>
    <p className={styles.description}>
      <FormattedMessage message={item.description} />
    </p>
    <div className={styles.shape} aria-hidden="true" />
  </li>
);

export { HowAcademyWorksItem };
